import { bull, nbsp } from 'mk/bazaar/common/entities';
import React from 'react';

interface OwnProps {
    className?: string;
    spaces?: number;
}

type Props = OwnProps;

const Dot: React.FunctionComponent<Props> = ({ className, spaces = 2 }) => (
    <span className={className}>
        {nbsp.repeat(spaces)}{bull}{nbsp.repeat(spaces)}
    </span>
);

Dot.displayName = 'Dot';

export default Dot;
